<script lang="ts" setup>
/**
 * トークルーム情報 > 投稿内容。
 */

import { defineProps } from "vue";

interface Props {
	/**
	 * トークルーム内容。
	 */
	contents: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<p class="revico-community-talk-talkroom-details--contents" v-html="contents"></p>
</template>

<style lang="scss">
.revico-widget .revico-community-talk .revico-community-talk {
	&-talkroom-details {
		&--contents {
			width: 100%;
			white-space: pre-wrap;
			overflow-wrap: break-word;
		}
	}
}
</style>
